export default __webpack_public_path__ + "static/shostakovich-cis-moll-da3407084dae3c79c8e68f31ded01168.mp3";